import {Action} from '@ngrx/store';
import {type} from '../utilities/type';


export const projectEditActionTypes = {
  CREATION: type('[project] Edit'),
  CREATION_W: type('[project] Edit 2'),
  CREATION_SUCCESS: type('[project] Edit Success'),
  CREATION_FAIL: type('[project] Edit Fail'),
  CREATION_MISMATCHING_FAIL: type('[project] Edit Mismatching Fail'),
};

export class ProjectEditAction implements Action {
  readonly type = projectEditActionTypes.CREATION;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class ProjectEditWithOutAction implements Action {
  readonly type = projectEditActionTypes.CREATION_W;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class ProjectEditSuccessAction implements Action {
  readonly type = projectEditActionTypes.CREATION_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class ProjectEditFailAction implements Action {
  readonly type = projectEditActionTypes.CREATION_FAIL;
  constructor(public payload?: string) {}
}
export class ProjectEditMismatchingFailAction implements Action {
  readonly type = projectEditActionTypes.CREATION_MISMATCHING_FAIL;
  constructor(public payload?: string[]) {}
}

